<template>
    <div style="direction: ltr" v-if="countDaysFreeTrialDuration > 0">
        <!--
        note: inline styling is required to make sure this graphic
              works on both desktop and mobile, and displays the correct data in the right proportions
              without having to redo everything every time the trial period changes
    -->
        <!-- TODO dream up a way to make this thing less messy - maybe turn this into an svg -->
        <!-- TODO maybe do cross-browser testing -->
        <div
            v-if="!isMobile && !isSmallMobile && showGraphic"
            class="br-50 rounded-right-0 position-relative text-left"
            style="
                height: 20px;
                background: linear-gradient(90deg, #00c851 60%, #00c851 80%, #00c85100);
                margin-bottom: 5rem;
                margin-top: 2rem;
            "
        >
            <div class="w-75 h-100 position-relative d-inline-block br-50 bg-success">
                <span class="position-absolute" style="bottom: calc(100% + 0.5rem)">
                    <br />
                    <strong>{{ 'Today' | trans }}</strong>
                </span>
                <span
                    class="position-absolute bg-white left-0"
                    style="
                        height: 22px;
                        width: 22px;
                        top: -1px;
                        border-radius: 100%;
                        box-shadow: rgba(0, 0, 0, 0.2) 0 0 4px 1px;
                    "
                ></span>
                <span
                    class="position-absolute left-0"
                    :style="`max-width: calc(100% * ${countDaysReminderBeforeTrialEnd} / ${
                        2 * countDaysFreeTrialDuration
                    });`"
                    style="top: calc(100% + 0.5rem)"
                >
                    {{ '%count% day trial starts' | trans({ '%count%': countDaysFreeTrialDuration }) }}
                </span>
                <div
                    class="position-absolute"
                    :style="`left: calc(100% * ${
                        countDaysFreeTrialDuration - countDaysReminderBeforeTrialEnd
                    } / ${countDaysFreeTrialDuration});`"
                    style="
                        height: 140%;
                        box-sizing: border-box;
                        padding-left: 3px;
                        background: rgb(46, 46, 46);
                        border-left: 2px solid whitesmoke;
                        border-right: 2px solid whitesmoke;
                    "
                >
                    <span class="position-absolute" style="top: 100%; left: -0.5ch; width: 100vw; max-width: 100px"
                        ><i class="far fa-envelope"></i>
                        {{ '%count% day reminder' | trans({ '%count%': countDaysReminderBeforeTrialEnd }) }}</span
                    >
                </div>
            </div>
            <div class="position-relative d-inline-block h-100 z-index-1" style="width: 22px; margin-left: -22px">
                <span
                    class="position-absolute white-space-nowrap text-center"
                    style="bottom: calc(100% + 0.5rem); left: -50%"
                >
                    <strong>{{ dateFirstChargeShort }}</strong>
                </span>
                <span
                    class="position-absolute bg-white left-0"
                    style="
                        height: 22px;
                        width: 22px;
                        top: -1px;
                        border-radius: 100%;
                        box-shadow: rgba(0, 0, 0, 0.2) 0 0 4px 1px;
                    "
                ></span
                ><span
                    class="position-absolute white-space-nowrap text-center"
                    style="top: calc(100% + 0.5rem); left: -50%"
                >
                    {{ 'First bill' | trans }}
                </span>
            </div>
        </div>

        <ul class="list-unstyled mb-0">
            <li class="py-2 d-flex align-items-baseline">
                <i class="fa fa-check text-success"></i>
                <span class="pl-1">{{
                    "We'll remind you %count% days before the free trial ends."
                        | trans({ '%count%': countDaysReminderBeforeTrialEnd })
                }}</span>
            </li>
            <li class="py-2 d-flex align-items-baseline">
                <i class="fa fa-check text-success"></i>
                <span class="pl-1" v-html="noChargeUntilText"></span>
            </li>
            <li class="py-2 d-flex align-items-baseline">
                <i class="fa fa-check text-success"></i>
                <span class="pl-1" v-html="youWillPayText"></span>
            </li>
        </ul>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../../../qaamgo/helper/translate';

export default {
    name: 'TrialInfoGraphic',
    mixins: [TransFilter],
    props: {
        countDaysFreeTrialDuration: {
            // length of free trial in days
            type: Number,
            required: true,
        },
        countDaysReminderBeforeTrialEnd: {
            // number of days before end of trial when we send a payment reminder email
            type: Number,
            required: true,
        },
        dateFirstChargeShort: {
            // formatted, localized date string (without year) of when the trial ends/user has to pay
            type: String,
            required: true,
        },
        dateFirstChargeFull: {
            // formatted, localized date string (with year) of when the trial ends/user has to pay
            type: String,
            required: true,
        },
        priceAtTrialStart: {
            // formatted, localized string of price user has to pay immediately (most likely 0.00€/$)
            type: String,
            required: true,
        },
        showGraphic: {
            type: Boolean,
            default: true,
        },
    },
    beforeMount() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 500px)').matches;
            this.isSmallMobile = window.matchMedia('(max-width: 320px)').matches;
        },
    },
    data() {
        return {
            isMobile: false,
            isSmallMobile: false,
        };
    },
    computed: {
        noChargeUntilText: function () {
            return translate('No charge until <strong>%date%</strong>', { '%date%': this.dateFirstChargeFull });
        },
        youWillPayText: function () {
            return translate('You will pay <strong>%amount%</strong> now. Set up payment for later.', {
                '%amount%': this.priceAtTrialStart,
            });
        },
    },
};
</script>
